<template>
  <TabContentLayout id="troubleshooting-tab">
    <b-row class="mb-2">
      <b-col>
        <SubHeaderSection
          title="Troubleshooting"
          description="Diagnóstico guiado"
          bg-icon="#1d58b7"
          bg-color="#f0f0f0"
          class="pl-1"
        >
          <font-awesome-icon :icon="['fas', 'clipboard-list-check']" size="xl" fixed-width />
        </SubHeaderSection>
      </b-col>
    </b-row>

    <b-row v-if="Object.keys(troubleshooting).length > 0" class="mb-2">
      <b-col >
        <div class="ts-summary-card mb-2">
          <div class="ts-summary-body">
            <div v-for="(question, i) in troubleshooting.questions" :key="i" class="ts-summary-item">
              <span class="ts-summary-num">{{ i + 1 }}</span>
              <span class="ts-summary-q">{{ question.text }}</span>
              <div class="d-flex">
                <b-button
                  type="button"
                  size="sm"
                  style="width: 45px;"
                  :variant="question.answer === 'Sí' ? 'primary' : 'outline-secondary'"
                  disabled
                >
                  Sí
                </b-button>
                <b-button
                  type="button"
                  size="sm"
                  style="width: 45px;"
                  :variant="question.answer === 'No' ? 'primary' : 'outline-secondary'"
                  class="ml-2"
                  disabled
                >
                  No
                </b-button>
              </div>
            </div>
          </div>
        </div>

        <div class="mb-2">
          <p class="pb-0 mb-0 align-self-baseline pt-1"><span>¿Se solucionó el problema?</span></p>
          <b-form-group class="mb-0">
            <div class="d-flex ml-2 mt-1" style="gap: 8px;">
              <b-button
                type="button"
                size="sm"
                style="width: 55px;"
                disabled
                :variant="troubleshooting.is_solved === 'Sí' ? 'primary' : 'outline-secondary'"
              >
                Sí
              </b-button>
              <b-button
                type="button"
                size="sm"
                style="width: 55px;"
                :variant="troubleshooting.is_solved === 'No' ? 'primary' : 'outline-secondary'"
                disabled
              >
                No
              </b-button>
            </div>
          </b-form-group>
        </div>

        <b-form-group v-if="troubleshooting.is_solved === 'Sí'">
          <template #label>
            <span>Comentario de solución</span>
          </template>
          <b-form-textarea
            :value="troubleshooting.solved_comment"
            rows="3"
            disabled
            placeholder="Describa la solución aplicada"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <div v-else class="ts-summary-card-empty">
      <p class="text-secondary text-center mb-0 fs-18">No hay datos para mostrar del troubleshooting</p>
    </div>
  </TabContentLayout>
</template>

<script>
  import TabContentLayout from './TabContentLayout'
  import SubHeaderSection from '../SubHeaderSection'

  export default {
    name: 'TroubleshootingTab',
    components: { TabContentLayout, SubHeaderSection },
    props: {
      troubleshooting: {
        type: Object,
        required: true,
        default: () => ({})
      }
    }
  }
</script>

<style scoped>
.ts-summary-card { border: 1px solid #a9b4cf6d; border-radius: 9px; background: #e9ecef; padding: 14px 16px; }
.ts-summary-card-empty { border: 1px solid #a9b4cf6d; border-radius: 9px; background: #e9ecef; padding: 14px 16px; }

.ts-summary-item { display: flex; align-items: center; justify-content: space-between; padding: 5px 0; border-bottom: 1px solid #dcfce7; font-size: 1rem; }
.ts-summary-item:last-child { border-bottom: none; }
.ts-summary-q { color: #374151; flex: 1; }
.ts-summary-num { width: 20px; height: 20px; border-radius: 50%; background: #f0ede6; color: #888; display: flex; align-items: center; justify-content: center; font-size: 0.9rem; font-weight: 700; flex-shrink: 0; margin-right:12px; }
.ts-summary-a { font-weight: 700; font-size: 0.72rem; padding: 1px 8px; border-radius: 10px; }
</style>
